import { useState, useLayoutEffect, useEffect } from "react";
import { trackPage, initPixel } from "../services/analytics";
import { useLocation } from "react-router-dom";
import { GlobalStore } from "../stores/global";

export default () => {
  const location = useLocation();
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    initPixel(countryCode);
  }, [countryCode]);

  useLayoutEffect(() => {
    if (process.env.REACT_APP_BUILD_ENV !== "production") return;
    console.log("Should track page in production for", location.pathname);
    trackPage(location.pathname);
    setReady(true);
  }, [location.pathname, countryCode]);

  return ready;
};
